import * as actionTypes from "../actions/actionTypes";

const initialState = {
  widget: null,
  freeSlots: null,
  steps: 4,
  place: null,
  manyPlaces: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_WIDGET_INFO:
      return {
        ...state,
        widget: action.payload,
      };
    case actionTypes.SET_FREE_SLOTS:
      return {
        ...state,
        freeSlots: action.payload,
      };
    case actionTypes.SET_STEPS:
      return {
        ...state,
        steps: action.payload,
      };
    case actionTypes.SET_PLACE:
      return {
        ...state,
        place: action.payload,
      };
    case actionTypes.SET_MANY_PLACES:
      return {
        ...state,
        manyPlaces: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
